// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1Rv8L {\n  margin: auto;\n  text-align: center;\n  width: 95%;\n}\n._3q2bi {\n  overflow-x: scroll;\n  overflow-y: hidden;\n  height: 40px;\n  white-space: nowrap;\n}\n._3q2bi::-webkit-scrollbar {\n  display: none;\n}\n._2mTte {\n  margin: 2px;\n  max-height: 50px;\n  cursor: pointer;\n  display: inline-block;\n  padding: 9px 4px 9px 4px;\n  font-size: 14px;\n  color: #9f9f9f;\n  position: relative;\n}\n._1G4xt {\n  color: #ffffff;\n  font-weight: bold;\n  font-size: 12px;\n}\n._22h7D {\n  border-bottom: 2px solid #2996ff;\n  width: 36px;\n  position: relative;\n  left: 17px;\n  top: 9px;\n}\n.kY1h6 {\n  color: white;\n  font-weight: bold;\n}\n.kY1h6::before {\n  position: absolute;\n  height: 2px;\n  width: 30%;\n  background: #2996ff;\n  content: '';\n  bottom: 0;\n  left: 50%;\n  -webkit-transform: translate(-50%, 0);\n      -ms-transform: translate(-50%, 0);\n          transform: translate(-50%, 0);\n}\n", ""]);
// Exports
exports.locals = {
	"wrappers": "_1Rv8L",
	"scrolls": "_3q2bi",
	"date__item": "_2mTte",
	"todayWhite": "_1G4xt",
	"todayBlue": "_22h7D",
	"date__active__white": "kY1h6"
};
module.exports = exports;
